import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { MatButton } from "@angular/material/button";
import { ReleaseCalendarData, ReleaseCalendarSelectedOptions } from "../../types/release-calendar-types";
import { UtilityService } from "../../../../../core/services/utility.service";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { ZOOM_OPTIONS } from "../../../../../core/constants/constants";
import { ReleaseCalendarPageModalsService } from "../../services/release-calendar-page-modals.service";
import { LoadingService } from "../../../../../core/services/loading.service";

@Component({
  selector: 'div[app-release-calendar-page-info]',
  imports: [
    MatButton,
    MatOption,
    MatSelect
  ],
  templateUrl: './release-calendar-page-info.component.html',
  styleUrl: './release-calendar-page-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseCalendarPageInfoComponent {
  releaseCalendarData = model.required<ReleaseCalendarData | null>();
  releaseCalendarSelectedOptions = model.required<ReleaseCalendarSelectedOptions | null>();
  visibleGroups = model.required<Array<boolean>>();
  currentZoomOption = model.required<number>();

  private utilityService: UtilityService = inject(UtilityService);
  private releaseCalendarPageModalsService: ReleaseCalendarPageModalsService = inject(ReleaseCalendarPageModalsService);
  private loadingService: LoadingService = inject(LoadingService);

  public readonly ZOOM_OPTIONS = ZOOM_OPTIONS;
  public totalExpenses = computed(() => {
    const totalExpenses = this.releaseCalendarData()?.totalExpenses;
    const maximumFractionDigits = totalExpenses ? 2 : 0;
    return this.utilityService.formatBudgetValue({ value: totalExpenses || 0, maximumFractionDigits });
  });

  public btnText = computed<string>(() =>
    !this.releaseCalendarSelectedOptions() ?
      'Выберите дату' :
      `${this.releaseCalendarSelectedOptions()?.monthName} ${this.releaseCalendarSelectedOptions()?.year}`
  );

  public handleOpenModal() {
    const currentVisibleGroups = this.visibleGroups();
    this.visibleGroups.set([]);
    this.releaseCalendarPageModalsService.openReleaseCalendarModal(this.releaseCalendarSelectedOptions())
      .subscribe((result) => {
        if (this.releaseCalendarPageModalsService.isReleaseCalendarResult(result)) {
          this.releaseCalendarData.set(result.data);
          this.releaseCalendarSelectedOptions.set(result.releaseCalendarSelectedOptions);
        }

        this.visibleGroups.set(currentVisibleGroups);
        this.loadingService.setIsLoadingState(false);
      });
  }
}
